<!-- Page Content -->
<div id="page-content">
  <div class="container">

    <div class="row" *ngIf="!geoData">
      <div class="col-md-12">
        <br>
        <h4 style="text-align: center">No Weather information today</h4>
        <h6 style="text-align: center">For past weather details, please contact : Head, Department of Geography | geography@hss.ruh.ac.lk</h6>
        <br>
      </div>
    </div>

    <div class="row" *ngIf="geoData">
      <!--MAIN Content-->
      <div class="col-md-12">

        <div class="printDiv">
          <div id="daily-weather">
            <div>
              <br>
              <h3 style="text-align: center">Daily Weather Observation at Weather Station</h3>
              <h4 style="text-align: center">Department of Geography</h4>
              <h4 style="text-align: center">University of Ruhuna</h4>

              <div class="row">
                <table width="100%">
                  <tr>
                    <td style="text-align: left">
                      Date : {{geoData?.cdate | date}}
                    </td>
                    <td style="text-align: right">
                      Data Acquired Time : {{geoData?.ctime | date:'shortTime'}}
                    </td>
                  </tr>
                </table>
                <br>
              </div>

              <table border="1" style="border-collapse: collapse" class="col-md-12 mb-4 text-center" width="100%">
                <thead>
                <tr>
                  <th width="20px" rowspan="2">Daily</th>
                  <th width="50px" rowspan="2">R.H (%) </th>
                  <th width="50px" rowspan="2">TEMPERATURE (&deg;C)</th>
                  <th width="50px" colspan="4">RADIATION (W/m^2)</th>
                  <th width="50px" rowspan="2">Rainfall (mm)</th>
                  <th width="50px" rowspan="2">DAY TOTAL (mm)</th>
                  <th width="50px" colspan="2">WIND</th>
                </tr>
                <tr>
                  <th width="50px">TOTAL NET RADIATION </th>
                  <th width="50px">NET SHORT WAVE RADIATION</th>
                  <th width="50px">NET LONG WAVE RADIATION</th>
                  <th width="50px">ALBEDO</th>
                  <th width="50px">W.SPEED (Km/h)</th>
                  <th width="50px">W.DIRECTION</th>
                </tr>
                <tr>
                  <td style="text-align: center" height="35px"><b>AV</b></td>
                  <td style="text-align: center">{{geoData?.rhavg}}</td>
                  <td style="text-align: center">{{geoData?.tempavg}}</td>
                  <td style="text-align: center">{{geoData?.tndavg}}</td>
                  <td style="text-align: center">{{geoData?.nswravg}}</td>
                  <td style="text-align: center">{{geoData?.nlwravg}}</td>
                  <td style="text-align: center">{{geoData?.albavg}}</td>
                  <td style="text-align: center">{{geoData?.rfavg}}</td>
                  <td style="text-align: center" rowspan="3">{{geoData?.rfdaytot}}</td>
                  <td style="text-align: center">{{geoData?.wndavg}}</td>
                  <td style="text-align: center" rowspan="3">{{geoData?.wndirection}}</td>
                </tr>
                <tr>
                  <td style="text-align: center" height="35px"><b>Min</b></td>
                  <td style="text-align: center">{{geoData?.rhmin}}</td>
                  <td style="text-align: center">{{geoData?.tempmin}}</td>
                  <td style="text-align: center">{{geoData?.tndmin}}</td>
                  <td style="text-align: center">{{geoData?.nswrmin}}</td>
                  <td style="text-align: center">{{geoData?.nlwrmin}}</td>
                  <td style="text-align: center">{{geoData?.albmin}}</td>
                  <td style="text-align: center">{{geoData?.rfmin}}</td>
                  <td style="text-align: center">{{geoData?.wndmin}}</td>

                </tr>
                <tr>
                  <td style="text-align: center" height="35px"><b>Max</b></td>
                  <td style="text-align: center">{{geoData?.rhmax}}</td>
                  <td style="text-align: center">{{geoData?.tempmax}}</td>
                  <td style="text-align: center">{{geoData?.tndmax}}</td>
                  <td style="text-align: center">{{geoData?.nswrmax}}</td>
                  <td style="text-align: center">{{geoData?.nlwrmax}}</td>
                  <td style="text-align: center">{{geoData?.albmax}}</td>
                  <td style="text-align: center">{{geoData?.rfmax}}</td>
                  <td style="text-align: center">{{geoData?.wndmax}}</td>
                </tr>
                </thead>
                <tbody>
                </tbody>
              </table>

              <br>
              <p>
                <b>Note: AV:</b> Average, <b>Min:</b> Minimum, <b>Max:</b> Maximum, <b>R.H:</b> Relative Humidity, <b>W:</b> Wind, <b>N:</b> North, <b>W/m^2:</b> Watts per square meter, <b>Km/h:</b> Kilometer per hour, <b>mm:</b> Millimeters, <b>&deg;C:</b> Degree of Celsius
              </p>

              <br>

              <table style="border-collapse: collapse;">
                <tr>
                  <td style="border: 1px solid #828080; padding: 10px;">
                    <b>Formulas for Radiation:</b>
                    <ol>
                      <li><b>Total Net Radiation</b> = Net Sky Radiation - Net Ground Radiation</li>
                      <li><b>Net Short Wave Radiation</b> = Short Wave Radiation Up - Short Wave Radiation Down</li>
                      <li><b>Net Long Wave Radiation</b> = Long Wave Radiation Up - Long Wave Radiation Down</li>
                      <li><b>Albedo</b> = Short Wave Radiation Down / Short Wave Radiation Up</li>
                    </ol>
                  </td>

                </tr>
              </table>

              <br>

              <h6 style="text-align: center">For past weather details, please contact : Head, Department of Geography | geography@hss.ruh.ac.lk</h6>

              <br>

            </div>
          </div>
        </div>

      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
